import React, { useCallback, useEffect, useState } from "react";
import { Table } from "evergreen-ui";
import DataTableHead from "./DataTableHead";
import DataTableBody from "./DataTableBody";
import "../../assets/styles/table.scss";

// columns = [
//   {
//     key: // data entry element key (string)
//     name: // human readable text (string)
//     render: (entry) => react.children compatible return
//     actions: // column actions, show only on row hover
//     align: // column textAlign
//     flex: // column flex shortcut
//   },
//   ...
// ]

// data = [
//   { ... }, // data entry
//   ...
// ]

// onSelect = (entry) => {}

const DataTable = ({ columns, data: _data, onSelect }) => {
  const [data, setData] = useState();
  const [sortColumn, setSortColumn] = useState();
  const [sortInverse, setSortInverse] = useState(false);

  useEffect(() => {
    if (sortColumn) {
      setData(
        [..._data].sort(
          "key" in sortColumn
            ? (a, b) => {
                let sortComparison = 0;
                if (a[sortColumn.key] < b[sortColumn.key]) {
                  sortComparison = -1;
                }
                if (a[sortColumn.key] > b[sortColumn.key]) {
                  sortComparison = 1;
                }
                return sortInverse ? sortComparison * -1 : sortComparison;
              }
            : undefined
        )
      );
    } else {
      setData(_data);
    }
  }, [_data, sortColumn, sortInverse]);

  const handleColumnClick = useCallback(
    (column) => {
      if (column === sortColumn) {
        if (sortInverse) {
          setSortColumn();
          setSortInverse(false);
        } else {
          setSortColumn(column);
          setSortInverse(true);
        }
      } else {
        setSortColumn(column);
        setSortInverse(false);
      }
    },
    [sortColumn, sortInverse]
  );

  if (!columns || !data) {
    return null;
  }

  return (
    <Table className="table">
      <DataTableHead
        columns={columns}
        onColumnClick={handleColumnClick}
        sortColumn={sortColumn}
        sortInverse={sortInverse}
      />
      <DataTableBody columns={columns} data={data} onSelect={onSelect} />
    </Table>
  );
};

export default DataTable;
